<template lang="pug">
button.button.is-small.back-button(@click="$emit('click')")
  span Volver atrás
</template>

<script>
export default {
  name: 'GoBackButton'
}
</script>

<style scoped lang="stylus">
@import '~@/styles/variables'

$back-button-width = $f200px

.back-button
  background: #ef7926
  border-top-right-radius: 0
  border: 0
  box-shadow: 0 0 $f20px grey
  box-sizing: border-box
  display: flex
  justify-content: center
  color: #fff
  font-size: 1rem
  font-weight: bold
  height: auto
  line-height: 1
  margin-top: $f20px
  padding: $f3px 0
  position: absolute
  width: $back-button-width
  bottom: $footer-max-height + $f10px
  right: 5%
  &:before
    border-bottom: $f15px solid #ef7926
    border-left: $back-button-width solid transparent
    content: ''
    width: 0
    height: 0
    position: absolute
    bottom: 100%
    left: 0
    @media screen and (min-width: $large-responsive-size)
      border-left-width: 10vmax
      border-left-width: 10vw
  @media screen and (min-width: $large-responsive-size)
    font-size: 1vmax
    font-size: 1vw
    width: 10vmax
    width: 10vw
  span
    display: inline-block

.isMobile
  .back-button
    bottom: $footer-max-height + $f75px

.drop
  animation: drop 1s forwards

.bump
  animation: drop 1s reverse

@keyframes drop
  from
    background: 140px;
  to
    bottom: 10px;

</style>
